import datapoint from '../../datapoints';
import favoritesStore from '../../store/store';
import moveDragAndDroppableItem from 'owa-dnd/lib/utils/moveDragAndDroppableItem';
import updateFavoritesUserOption from './updateFavoritesUserOption';
import { select } from 'satcheljs/lib/legacy';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';

export interface MoveFavoriteToPositionState {
    orderedFavoritesNodeIds: string[];
}

/**
 * Move the favorite node before the specified node
 * @param favoriteIdToUpdate the id to be moved
 * @param destinationFavoriteId the id to be inserted before
 */
export default createLegacyActionWithDatapoint(
    'moveFavoriteToPosition',
    datapoint.UpdateFavoriteNode
)(
    select({
        orderedFavoritesNodeIds: () => favoritesStore.orderedFavoritesNodeIds,
    })(function moveFavoriteToPosition(
        favoriteIdToUpdate: string,
        destinationFavoriteId: string,
        state?: MoveFavoriteToPositionState
    ) {
        const { orderedFavoritesNodeIds } = state;

        const fromIndex = orderedFavoritesNodeIds.indexOf(favoriteIdToUpdate);
        const toIndex = orderedFavoritesNodeIds.indexOf(destinationFavoriteId);

        // Move the element from the old position to the new position in the array
        moveDragAndDroppableItem(orderedFavoritesNodeIds, fromIndex, toIndex);

        // Update user options service which is used by OWA
        updateFavoritesUserOption();
    })
);
